export function calculatePOD({
  sucrose = 0,
  glucose = 0,
  fructose = 0,
  lactose = 0,
  maltose = 0,
  galactose = 0,
}: Partial<{
  sucrose: number;
  glucose: number;
  fructose: number;
  lactose: number;
  maltose: number;
  galactose: number;
}>): number {
  // https://en.wikipedia.org/wiki/Sweetness
  const sucrosePOD = sucrose * 1;
  const glucosePOD = glucose * 0.74;
  const fructosePOD = fructose * 1.45;
  const lactosePOD = lactose * 0.16;
  const maltosePOD = maltose * 0.4;
  const galactosePOD = galactose * 0.65;

  return (
    sucrosePOD +
    glucosePOD +
    fructosePOD +
    lactosePOD +
    maltosePOD +
    galactosePOD
  );
}
